import { render, staticRenderFns } from "./payFeeDiscount.vue?vue&type=template&id=6e5f8730&scoped=true"
import script from "./payFeeDiscount.vue?vue&type=script&lang=js"
export * from "./payFeeDiscount.vue?vue&type=script&lang=js"
import style0 from "./payFeeDiscount.vue?vue&type=style&index=0&id=6e5f8730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5f8730",
  null
  
)

export default component.exports